<template>
	<div class="close-button" :class="{ 'has-circle-bg': hasCircle, disabled }">
		<SIcon name="close-x" />
	</div>
</template>

<script>
export default {
	name: 'CloseButton',
	props: {
		hasCircle: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
	},
};
</script>

<style scoped lang="scss">
.close-button::v-deep(svg) {
	&:hover {
		cursor: pointer;

		circle {
			fill: rgba(0, 0, 0, 0.2);
		}
		g {
			stroke: rgb(255, 255, 255);
		}
		circle,
		g {
			transition: 0.3s;
		}
	}

	&:not(:hover) ::v-deep(svg) {
		circle,
		g {
			transition: 0.2s;
		}
	}
}

.close-button:not(.has-circle-bg)::v-deep(svg) {
	circle {
		fill: transparent !important;
	}
}
.close-button {
	&.disabled {
		pointer-events: none;
		opacity: 0.5;
	}
}
</style>
